import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { useMemo } from 'react';
import { noop } from 'utility-belt/utilityFunctions';
import { events } from '../../../event-tracking';
import { unixTimestampToDate } from '../../../utils/dateTime';
import { useCommonValidation } from '../hooks/useCommonValidation';
import { ContractAction, ContractActions } from '../types';
import { ACTION_LOADING_MESSAGE_KEY, ActionValidationError } from '../utils/constants';
import { isActionUnavailable } from '../utils/utilities';
import { useContractData } from '../../../hooks/useFetchContractData';
import { hasContractM1Gate } from '../../../utils/gates';
const ManageTerminationActionConfig = {
  id: ContractActions.RESCHEDULE_TERMINATION,
  validationMessages: {
    [ActionValidationError.UNAUTHORIZED]: 'commerceContractLib.actions.RESCHEDULE_TERMINATION.errors.unauthorized',
    [ActionValidationError.JITA_USER]: 'commerceContractLib.actions.RESCHEDULE_TERMINATION.errors.jitaUser'
  },
  primaryLabel: 'commerceContractLib.actions.RESCHEDULE_TERMINATION.label',
  loadingMessageKey: ACTION_LOADING_MESSAGE_KEY
};
export const useManageTerminationAction = ({
  objectId,
  objectTypeId,
  skip
}) => {
  const queryData = useContractData({
    objectId,
    objectTypeId
  }, {
    skip
  });
  const validation = useCommonValidation({
    objectId,
    objectTypeId,
    actionID: ManageTerminationActionConfig.id,
    skip
  });
  const sendOpenManageTerminationModal = useSendCrmMessageTopic(TOPIC_NAMES.OPEN_CONTRACT_MANAGE_TERMINATION_MODAL);
  const {
    data
  } = queryData;
  return useMemo(() => {
    var _data$properties;
    const terminateDate = data === null || data === void 0 || (_data$properties = data.properties) === null || _data$properties === void 0 || (_data$properties = _data$properties.hs_termination_date) === null || _data$properties === void 0 ? void 0 : _data$properties.value;
    const isUnavailable = isActionUnavailable({
      objectId,
      objectTypeId,
      skip
    }) || !hasContractM1Gate() || validation.disabledReasons.has(ActionValidationError.UNAVAILABLE) || validation.disabledReasons.has(ActionValidationError.CONTRACT_TERMINATION_NOT_SCHEDULED) || validation.disabledReasons.has(ActionValidationError.CONTRACT_NOT_ACTIVE) || validation.disabledReasons.has(ActionValidationError.LOADING);
    if (isUnavailable) {
      return ContractAction.unavailable();
    }
    for (const reason of (_validation$disabledR = validation === null || validation === void 0 ? void 0 : validation.disabledReasons) !== null && _validation$disabledR !== void 0 ? _validation$disabledR : []) {
      var _validation$disabledR;
      const messageKey = ManageTerminationActionConfig.validationMessages[reason];
      if (messageKey) {
        return ContractAction.invalid({
          messageKey: ManageTerminationActionConfig.primaryLabel,
          validationMessageKey: messageKey,
          onClick: noop
        });
      }
    }
    return ContractAction.ok({
      messageKey: ManageTerminationActionConfig.primaryLabel,
      onClick: () => {
        events.RESCHEDULE_TERMINATION.open();
        sendOpenManageTerminationModal({
          contractId: objectId,
          terminationDate: terminateDate ? unixTimestampToDate(terminateDate, 'MMMM DD, YYYY') : null
        });
      }
    });
  }, [data, objectId, objectTypeId, skip, validation, sendOpenManageTerminationModal]);
};